// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop_NewBuildingSearchRoute" + "_" + "4f0d28cdbcd7e1b79a1f" + ".css";
};